import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { MaskitoDirective } from '@maskito/angular';
import { MaskitoElementPredicate } from '@maskito/core';
import { SharedModule } from '@app/shared/shared.module';
import { timeMask } from '@app/shared/masks/time.mask';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'c-time-input',
  imports: [MaskitoDirective, SharedModule],
  templateUrl: './time-input.component.html',
  styleUrl: './time-input.component.scss',
})
export class TimeInputComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() icon: IconProp;
  @Input() placeholder: string;
  @Input() showClearButton: boolean = false;
  @Input() showValidation: boolean;

  maskitoOptions = timeMask;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  readonly maskitoPredicate: MaskitoElementPredicate = async (el) => ((el as unknown) as HTMLIonInputElement).getInputElement();

  get control(): FormControl {
    return this.ngControl?.control as FormControl;
  }

  onInputChange(value: string): void {
    const digits = value.replace(/\D/g, '');

    // Check to prevent emitting timeMask as a value to the form, instead emitting null
    if (digits.length === 0) {
      this.onChange(null);
      return;
    }

    this.formatValue(value);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  writeValue(_: string): void {}

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  private onChange: (value: string) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/member-ordering
  private onTouched: () => void;

  private formatValue(value: string): void {
    let [hours = '', minutes = ''] = value.split(':');

    hours = hours.padStart(2, '0');
    minutes = minutes.padEnd(2, '0');

    const formatted = `${hours}:${minutes}`;

    this.onChange(formatted);
  }
}
